// extracted by mini-css-extract-plugin
export default {"Container":"Home_Container__NskhI"};